import { useFrame, useThree } from '@react-three/fiber';
import { useMemo, useRef } from 'react';
import { Vector3 } from 'three';

type Props = {
  disabled?: boolean;
};

export const MouseCamera = ({ disabled = false }: Props) => {
  const vec = useRef(new Vector3());

  const { camera, pointer } = useThree();
  const originalCameraPosition = useMemo(
    () => new Vector3().copy(camera.position),
    [camera]
  );

  useFrame(() => {
    const xCoordinate = Math.min(1, Math.max(-1, pointer.x)) * 0.5;
    camera.position.lerp(
      vec.current.set(
        disabled ? originalCameraPosition.x : xCoordinate,
        camera.position.y,
        camera.position.z
      ),
      0.05
    );
  });

  return null;
};

export default MouseCamera;
